<div class="d-flex flex-column justify-content-between">
  @if (!state.error) {
    <form
      autocomplete="off"
      [formGroup]="payattitudeForm"
      (ngSubmit)="onSubmitBtnClicked()"
    >
      <div class="row">
        <div class="form-group col-mb-12 mb-2">
          <div class="group-input mb-4">
            <label
              for="phone"
              class="zp:text-xs zp:font-medium zp:text-ZTN-500 zp:pb-2 zp:block"
              >Phone Number</label
            >
            <div class="tel-combined-input">
              <div class="combined-input-left">
                <svg-icon name="ngaFlag" svgClass="img-fluid w-50"></svg-icon>
                <span class="zp:block zp:text-base zp:m-1">+234</span>
              </div>
              <input
                (keypress)="checkDigit($event)"
                class="payattitude zp:text-base zp:border-0 zp:focus:outline-0 zp:focus:border-0 zp:border-transparent zp:w-full zp:rounded zp:py-3 zp:px-4 zp:text-ZTN-900 zp:placeholder:font-light zp:placeholder:text-ZTN-300 zp:h-[48px]"
                minlength="10"
                maxlength="10"
                id="payphone"
                name="payphone"
                type="tel"
                placeholder="0000 000 0000"
                formControlName="phone"
                required
              />
            </div>
          </div>
        </div>
        <div class="form-group col-md-12 zp:mt-6">
          <div class="form-button zp:text-center">
            <button
              class="zp:bg-ZTG-BC zp:text-center zp:text-white zp:w-full zp:rounded-lg zp:font-bold zp:text-sm zp:py-3 zp:cursor-pointer"
              type="submit"
              [disabled]="!payattitudeForm.valid"
              [ngClass]="{
                'omni-btn-loading': loading,
                'zp:bg-ZTG-300 zp:cursor-not-allowed': !payattitudeForm.valid,
              }"
            >
              <span
                >Pay <span>{{ transactionData?.currency }}</span>
                {{
                  amount
                    ? (amount
                      | currency: transactionData.currency : "symbol-narrow")
                    : ""
                }}
              </span>
            </button>
          </div>
          <div
            class="zp:bg-ZTN-50 zp:border zp:border-ZTN-200 zp:rounded-lg zp:p-1 zp:mt-10 zp:text-ZTN-500 zp:font-medium zp:text-sm"
          >
            <p
              class="zp:text-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-white zp:py-4 zp:px-1"
            >
              To complete this transaction, we have sent a prompt to the phone
              number you provided. Please, input your PIN on the prompt to
              approve this transaction securely.
            </p>
          </div>
        </div>
      </div>
    </form>
  }
  @if (state.error) {
    <div
      class="zp:font-mont zp:flex zp:justify-center zp:items-center zp:border zp:border-ZTN-200 zp:rounded-lg zp:bg-ZTN-50 zp:p-1"
    >
      <div
        class="zp:text-center zp:bg-white zp:rounded-lg zp:py-4 zp:px-2 zp:basis-full"
      >
        <div class="zp:flex zp:justify-center zp:items-center zp:mb-3">
          <svg-icon name="warning" svgClass="img-fluid w-50"></svg-icon>
        </div>
        <div class="px-3">
          <div
            class="zp:font-semibold zp:text-lg zp:text-ZTN-900 zp:leading-5 zp:pb-2"
          >
            We could not process this transaction
          </div>
          <div class="zp:text-sm zp:text-ZTN-500 zp:font-normal zp:leading-5">
            <small class="zp:text-sm">
              {{ errorMessage }}
            </small>
          </div>
        </div>
      </div>
    </div>
  }
</div>
